{
  "it": {
    "snippets": {
      "labels": {
        "cancel": "Annulla",
        "confirm": "Conferma",
        "create": "Crea un frammento",
        "delete": "Elimina",
        "edit": "Modifica",
        "editTitle": "Modifica frammento",
        "initMessage": "Selezioni un frammento per visualizzarne l'anteprima qui.",
        "language": "Lingua",
        "linkable": "Tipo",
        "linkableClient": "Team",
        "linkableEmployee": "Personale",
        "linkablePartner": "Partner",
        "manage": "Gestisca i Suoi frammenti",
        "manageMessage": "Oppure faccia clic qui per gestire tutti i Suoi frammenti nelle impostazioni dell'organizzazione",
        "message": "Messaggio",
        "messageError": "Inserisca un messaggio",
        "new": "Nuovo frammento",
        "noSnippets": "Non ha ancora frammenti.",
        "preview": "Anteprima",
        "save": "Salva",
        "search": "Cerca",
        "select": "Seleziona",
        "snippets": "Frammenti",
        "title": "Titolo",
        "titleError": "Inserisca un titolo"
      }
    }
  }
}
